import { TimeseriesIndicatorCode } from '@/interfaces/Timeseries.interface';
import { BudgetsProvider } from '@/providers/budgets/budgets.provider';
import { DashboardingProvider } from '@/providers/dashboarding.provider';
import { UiButtonComponent } from '@/ui/button/ui-button';
import { UiSectionActionsDirective } from '@/ui/section/section-actions/ui-section-actions';
import { UiSectionContentComponent } from '@/ui/section/section-content/ui-section-content';
import { UiSectionComponent } from '@/ui/section/ui-section';
import { isNotNullish } from '@/utils/typing/is-nullish.predicate';
import { AsyncPipe } from '@angular/common';
import { Component, type OnDestroy, type OnInit, inject } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import type { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { ExpenditureModes } from '../../../interfaces/energy-expenditure-balance.interface';
import type { EnergyExpenditureBalanceSettings, EnergyExpenditureBalanceTranslationKeys } from '../../../interfaces/Widget.interface';
import { VatModes } from '../../../providers/budgets/budgets.constants';
import { ProjectsProvider } from '../../../providers/projects/projects.provider';
import { WidgetProvider } from '../../../providers/widget.provider';
import { WidgetSize } from '../../../providers/widgets.contants';
import { Page, RoutingService } from '../../../services/routing/routing.service';
import { DegreeDaySelectorComponent } from '../../degree-day-selector/degree-day-selector';
import { EnergyExpenditureBalanceComponent } from '../../energy-expenditure-balance/energy-expenditure-balance';
import { EnergyExpenditureBalanceSelectorComponent } from '../../energy-expenditure-balance/energy-expenditure-balance-selector/energy-expenditure-balance-selector';
import { AbstractWidgetClass } from '../AbstractWidget.class';

@Component({
    styleUrls: ['./widget-energy-expenditure-balance.scss'],
    selector: 'widget-energy-expenditure-balance',
    templateUrl: 'widget-energy-expenditure-balance.html',
    imports: [
        UiSectionComponent,
        UiSectionActionsDirective,
        DegreeDaySelectorComponent,
        EnergyExpenditureBalanceSelectorComponent,
        UiButtonComponent,
        UiSectionContentComponent,
        EnergyExpenditureBalanceComponent,
        AsyncPipe,
        TranslatePipe
    ]
})
export class WidgetEnergyExpenditureBalanceComponent
    extends AbstractWidgetClass<EnergyExpenditureBalanceTranslationKeys, EnergyExpenditureBalanceSettings>
    implements OnInit, OnDestroy
{
    private _routingService = inject(RoutingService);
    private _projectsProvider = inject(ProjectsProvider);
    private _widgetsProvider = inject(WidgetProvider);
    private _dashboardingProvider = inject(DashboardingProvider);
    private _budgetsProvider = inject(BudgetsProvider);

    size = WidgetSize.FULL;

    isCostIndicatorCode!: boolean;
    vatMode$!: Observable<VatModes>;
    indicatorCode$!: Observable<TimeseriesIndicatorCode>;

    displayMode!: ExpenditureModes;
    ExpenditureModes = ExpenditureModes;

    isMonoBuilding$!: Observable<boolean>;

    canAccessToBudget$ = this._budgetsProvider.canAccessToBudget$();

    ngOnInit() {
        this.vatMode$ = this._projectsProvider.getVatMode$().pipe(filter(isNotNullish));
        this.isMonoBuilding$ = this._dashboardingProvider.getIsMonoBuilding$();
        this.isCostIndicatorCode = this._widgetsProvider.isIndicatorCodeCost(this.config.timeseriesIndicator);
        this.indicatorCode$ = this.vatMode$.pipe(
            map(vatMode =>
                this.isCostIndicatorCode
                    ? vatMode == VatModes.VAT_INCL
                        ? TimeseriesIndicatorCode.COST_VAT_INCL
                        : TimeseriesIndicatorCode.COST_VAT_EXCL
                    : this.config.timeseriesIndicator
            )
        );
    }

    ngOnDestroy(): void {}

    goToEditBudget() {
        this._routingService.goTo(Page.BUDGET_EDITION, {});
    }

    onModeSelect(mode: ExpenditureModes) {
        this.displayMode = mode;
    }
}
